export default {
	getAllItems: state => state.all_items,
	getCouponItems: state => state.coupon_items,
	getRedemptionItems: state => state.redemption_items,
	getTrailerItems: state => state.trailer_items,
	getTimeline: state => state.timeline,
	getPeriodicity: state => state.periodicity,
	getMaxValue: state => state.max_value,
	getMinValue: state => state.min_value,
}